import { create } from 'zustand';
import type { AppSession } from '@/services/appSession';

/**
 * 잠금 해제 상태. 잠그면 session(키·Repository 참조)을 null로 만들고,
 * VaultGate 아래 화면이 모두 unmount되어 화면에 있던 복호화 데이터도 함께 사라진다.
 */
type State = {
  session: AppSession | null;
  /** 로그인한 아이디 (화면 표시용, 메모리에만) */
  accountName: string | null;
  /** 이 기기에서 로그인 유지 중 (자동 잠금 안 함) */
  remembered: boolean;
  setRemembered: (on: boolean) => void;
  setSession: (s: AppSession) => void;
  setAccountName: (name: string) => void;
  lock: () => void;
};

export const useSession = create<State>((set) => ({
  session: null,
  accountName: null,
  remembered: false,
  setRemembered: (remembered) => set({ remembered }),
  setSession: (session) => set({ session }),
  setAccountName: (accountName) => set({ accountName }),
  lock: () => set({ session: null, accountName: null, remembered: false }),
}));

export function useRequiredSession(): AppSession {
  const s = useSession((x) => x.session);
  if (!s) throw new Error('잠금 해제가 필요합니다');
  return s;
}
